exports.list = {
    path: '/pengeluaran',
    name: 'pengeluaran_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/pengeluaran/List.vue"),
}
exports.show = {
    path: '/pengeluaran/show/:id',
    name: 'pengeluaran_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pengeluaran/Show.vue"),
}